import moment from "moment/moment";
import {indentation} from "@/helper/cut-num";
import {retainWan} from "@/plugins/helper";


const KEY_NAME_MAP = {
  commodityCount: '直播商品数',
  newCommodityCount: '新品数',
  salesVolume: '直播销量',
  sales: '直播销售额',
  anchorCount: '关联达人数',
  liveCount: '关联直播数',
  opusAnchorCount: '视频达人数',
  opusCount: '关联作品数'
}
const color = ['#5694FF', '#FFBA32']

const makeConfig = (legendData, xAxisData, yAxis, series,isSingle,legend) => ({
  tooltip: {
    backgroundColor: 'rgba(255,255,255,0.9)',
    trigger: 'axis',
    axisPointer: {
      type: "shadow"
    },
    formatter:(arr) =>{
      const {axisValue} = arr?.[0]
      return arr?.reduce((html,current) => {
        const { seriesName,data,color } = current
        const preIcon = seriesName === '直播销售额' ? '¥' : ''
        const marker = `<span style="display:inline-block;margin-right:5px;width:8px;height:8px;background-color:${color};border-radius: 50%"></span>`
        const formatData = preIcon + retainWan(data,false,2,'--')
        html+=`${marker}<span>${seriesName}</span>&nbsp&nbsp<span style="float: right">${formatData}</span><br/>`
        return html
      },`<div>${axisValue}</div>`)
    },
  },
  legend: legend,
  grid: isSingle
    ? {left: 40, top: 60, bottom: 20, right: 20}
    : {left: 60, top: 60, bottom: 20, right: 60},
  xAxis: {
    data: xAxisData,
    type: 'category',
    axisLabel: {textStyle: {color: '#848f9c'}},
    axisLine: {lineStyle: {color: '#E7E7E7'}},
    axisTick: { show: false },
  },
  yAxis,
  series
})
const makelegend = (key,legendData) => {
  if(key[0] =="salesVolume") {
    return {
      top: 18,
      data: legendData,
      itemWidth:8,
      itemHeight:8,
      icon:'rect',
      itemGap:24,
      orient: 'horizontal',
      lineStyle:{
        color:'rgba(221,221,221,0)'
      }
    }
  } else {
    return {
      top: 18,
      right:0,
      data: legendData,
      itemWidth:8,
      itemHeight:8,
      icon:'rect',
      itemGap:24,
      orient: 'horizontal',
      lineStyle:{
        color:'rgba(221,221,221,0)'
      }
    }
  }
}
const makeLegend = (key) => KEY_NAME_MAP[key]
const makeXAxisData = (data, key) => data?.[key]?.map(ele => moment(ele,'YYYYMMDD').format('MM-DD'))
// 根据key匹配双轴线
const makeYAxis = (key,index) => ({
  type: 'value',
  name: KEY_NAME_MAP[key],
  axisLabel: {
    formatter: val => indentation(val),
    color: '#696D75',
  },
  position: index === 0 ? 'left' : 'right',
  axisLine: { show: false },
  axisTick: { show: false },
  splitNumber:5,
  min:0,
  boundaryGap:true,
  splitLine: {
    lineStyle: {
      color: ['#E7E7E7']
    }
  },
  nameTextStyle:{
    color:'#4A4A4A',
    fontSize:12,
    align: index === 0 ? 'right' : 'left',
  },
  nameGap:25
})
const makeSingleYAxis = (keys) => ({
  name: keys?.reduce((total,key,index) => total += (index === 0 ? '' : '/') + KEY_NAME_MAP[key],''),
  type: 'value',
  axisLabel: {
    formatter: val => indentation(val),
    color: '#696D75',
    margin: -20,
  },
  offset: 40,
  position: 'left',
  axisLine: { show: false },
  axisTick: { show: false },
  minInterval: 1,
  min:0,
  boundaryGap:true,
  splitLine: {
    lineStyle: {
      color: ['#E7E7E7']
    }
  },
  nameTextStyle:{
    color:'#4A4A4A',
    fontSize:12,
    align: 'left',
  },
  nameGap:25
})
const makeSeries = (data, key, index,isSingle) => ({
  name: KEY_NAME_MAP[key],
  type: 'bar',
  barMaxWidth: 30,
  data: data?.[key]?.map(ele => parseInt(ele)),
  color: color[index],
  yAxisIndex: isSingle ? 0 : index,
  animationEasing: 'elasticOut',
  animationDelay: (idx) => idx * 100
})

export const makeChart = (data = {}, keys = []) => {
  const xAxisData = makeXAxisData(data, 'date')
  const isSingleYAxis = !keys?.includes('sales')
  let {yAxis,series, legendData} = keys?.reduce((total, key, index) => {
    total.yAxis.push(makeYAxis(key,index))
    total.series.push(makeSeries(data, key, index,isSingleYAxis))
    total.legendData.push(makeLegend(key))
    return total
  }, {yAxis:[],series: [], legendData: []})
 const legend =  makelegend(keys,legendData)
  if(isSingleYAxis) yAxis = makeSingleYAxis(keys) // 设置单轴
  return makeConfig(legendData, xAxisData, yAxis, series,isSingleYAxis,legend)
}